import { chainReducers, createApiReducer, INITIAL_API_STATE } from 'services/api';
import { transformSetting } from '../transformation';
import { SettingsActionTypes } from './actions';



const fetchSettingsReducer = createApiReducer(
  [
    SettingsActionTypes.FETCH_SETTINGS_START,
    SettingsActionTypes.FETCH_SETTINGS_SUCCESS,
    SettingsActionTypes.FETCH_SETTINGS_FAILURE,
  ],
  transformSetting,
  data => data,
);

const tenantChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchSettingsReducer
);

export default tenantChainedReducers;



